import { call } from '@advanza/api'
import { formatPriceWithCurrency } from '@advanza/func'
import { LoadingDots } from '@advanza/ui'
import { useEffect, useState } from 'react'

interface CreditLimitsData {
    limits: number[]
    enableCreditLimits: boolean
}

interface Props {
    serviceId: number
}

const ServiceCreditLimitsInfo = ({ serviceId }: Props) => {
    const [data, setData] = useState<CreditLimitsData | undefined>()

    useEffect(() => {
        call(`office/services/get-credit-limits/${serviceId}`).then((response) => {
            setData(response.data)
        })
    }, [serviceId])

    if (!data) {
        return <LoadingDots />
    }

    return (
        <div>
            <h2 className="m-0 mb-4 text-xl font-semibold text-bodyDark">Credit Limits</h2>
            {data.enableCreditLimits ? (
                <div className="flex flex-wrap gap-2">
                    {data.limits.map((limit) => (
                        <div
                            key={limit}
                            className="rounded bg-grey-200 px-3 py-1.5 text-md font-medium">
                            {formatPriceWithCurrency(limit)}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-md text-grey-800">
                    Credit limits are not enabled for this service.
                </div>
            )}
        </div>
    )
}

export default ServiceCreditLimitsInfo
